// extracted by mini-css-extract-plugin
module.exports = {"bold":"Upload_bold__1Q9l1"};